import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CTAGaleria() {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="bg-black py-20">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="bg-gradient-to-br from-amber-500/10 to-yellow-500/10 border border-amber-500/30 rounded-3xl p-12 relative overflow-hidden">
          {/* Background Effects */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/5 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-yellow-500/5 rounded-full blur-3xl"></div>

          {/* Content */}
          <div className="relative z-10">
            {/* Icon */}
            <div 
              className={`w-20 h-20 bg-gradient-to-br from-amber-500 to-yellow-500 rounded-2xl flex items-center justify-center mx-auto mb-6 transition-all duration-700 ${
                isVisible ? 'opacity-100 scale-100 rotate-0' : 'opacity-0 scale-50 rotate-12'
              }`}
            >
              <i className="ri-quill-pen-line text-4xl text-black"></i>
            </div>

            {/* Title */}
            <h2 
              className={`font-playfair text-4xl md:text-5xl font-bold text-white mb-4 transition-all duration-700 delay-100 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              Escreva Sua Própria História
            </h2>

            {/* Description */}
            <p 
              className={`text-gray-300 text-lg mb-8 max-w-2xl mx-auto transition-all duration-700 delay-200 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              Inspire-se nessas histórias e comece a escrever cartas para o seu eu futuro. 
              Transforme seus sonhos em realidade através da escrita reflexiva.
            </p>

            {/* Button */}
            <button
              onClick={() => navigate('/dashboard')}
              className={`px-8 py-4 bg-gradient-to-r from-amber-500 to-yellow-500 text-black font-bold text-lg rounded-full hover:shadow-2xl hover:shadow-amber-500/30 transition-all duration-700 delay-300 whitespace-nowrap ${
                isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-90'
              } hover:scale-105`}
            >
              Começar Agora
            </button>

            {/* Trust Badges */}
            <div 
              className={`flex items-center justify-center gap-6 mt-8 transition-all duration-700 delay-400 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
            >
              <div className="flex items-center gap-2 text-gray-400 text-sm">
                <i className="ri-shield-check-line text-amber-400"></i>
                <span>100% Privado</span>
              </div>
              <div className="flex items-center gap-2 text-gray-400 text-sm">
                <i className="ri-time-line text-amber-400"></i>
                <span>Entrega Programada</span>
              </div>
              <div className="flex items-center gap-2 text-gray-400 text-sm">
                <i className="ri-heart-line text-amber-400"></i>
                <span>Gratuito para Começar</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
